import React from 'react';
import './Policies.scss';

const Policies = () => {
  return (
    <div className="footer">
      <div className="footer__bottom">
        <div className="footer__policies">
          <div>
            <span className="footer__link"><a href='/terms-of-service'>Terms of Use</a></span>
          </div>
          <div>
            <span className="footer__link"><a href='/privacy-policy'>Privacy Policy</a></span>
          </div>
          <div>
            <span className="footer__link"><a href='/cookie-policy'>Cookie Policy</a></span>
          </div>
          <div>
            <span className="footer__link"><a href='/security-policy'>Security Policies</a></span>
          </div>
        </div>
        <div className="footer__copyright">
          &copy; 2024 M2R2. All Rights Reserved.
        </div>
      </div>
    </div>
  );
};

export default Policies;
